'use strict';

angular.module('shiftTraderApp')
  .controller('ModalClearDayCtrl', function($scope, params, $uibModalInstance) {
    $scope.org = params.org;
    $scope.currentDate = params.currentDate;
    $scope.workPeriods = params.workPeriods;

    $scope.state = {
      assignmentSelection: 'both',
      publishSelection: 'unpublished'
    };

    $scope.close = function() {
      $uibModalInstance.dismiss();
    };

    $scope.allDepartments = _.map(_.cloneDeep($scope.org.departments), function(dept) {
      dept._selected = false;
      return dept;
    });

    $scope.selectAllPositionsInDept = function(dept) {
      _.each(dept.positions, function(pos) {
        if (pos._numWorkPeriods > 0) {
          pos._selected = true;
        }
      });

      dept._anySelected = true;
      dept._allSelected = true;
      updateTotalNumWorkPeriodsSelected();
    };

    $scope.deselectAllPositionsInDept = function(dept) {
      _.each(dept.positions, function(pos) {
        pos._selected = false;
      });

      dept._anySelected = false;
      dept._allSelected = false;
      updateTotalNumWorkPeriodsSelected();
    };

    var updateDepartmentAnyAll = function(dept) {
      dept._anySelected = _.any(dept.positions, function(pos) {
        return pos._selected && pos._numWorkPeriods > 0;
      });

      dept._allSelected = _.all(dept.positions, function(pos) {
        return pos._selected || pos._numWorkPeriods === 0;
      });
    };

    $scope.togglePositionSelection = function(pos) {
      pos._selected = !pos._selected;

      var dept = _.find($scope.allDepartments, {id: pos.department_id});
      updateDepartmentAnyAll(dept);
      updateTotalNumWorkPeriodsSelected();
    };

    $scope.closeAndClear = function() {
      var workPeriodIds = [];
      _.each($scope.allDepartments, function(dept) {
        _.each(dept.positions, function(pos) {
          if (pos._selected) {
            _.each(pos._workPeriods, function(wp) {
              workPeriodIds.push(wp.id);
            });
          }
        });
      });

      $uibModalInstance.close(workPeriodIds);
    };

    $scope.countSelectedWorkPeriods = function(dept) {
      return +_.reduce(_.map(dept.positions, function(pos) {
        if (pos._selected) {
          return pos._numWorkPeriods;
        } else {
          return 0;
        }
      }), function(x,y) {
        return x + y;
      }, 0);
    };

    $scope.isSomethingSelected = function() {
      return _.any(_.map($scope.allDepartments, function(dept) {
        return _.any(dept.positions, function(pos) {
          return pos._selected;
        });
      }));
    };

    var setAssignmentPublishState = function() {
      $scope.state.anyAssignment = $scope.state.assignmentSelection === 'both';
      $scope.state.unassignedOnly = $scope.state.assignmentSelection === 'unassigned';
      $scope.state.assignedOnly = $scope.state.assignmentSelection === 'assigned';

      $scope.state.anyPublish = $scope.state.publishSelection === 'both';
      $scope.state.unpublishedOnly = $scope.state.publishSelection === 'unpublished';
      $scope.state.publishedOnly = $scope.state.publishSelection === 'published';
    };

    var updateTotalNumWorkPeriodsSelected = function() {
      $scope.state.totalNumWorkPeriodsSelected = 0;

      _.each($scope.allDepartments, function(dept) {
        $scope.state.totalNumWorkPeriodsSelected += $scope.countSelectedWorkPeriods(dept);
      });
    };

    var calcNumWorkPeriods = function() {
      _.each($scope.allDepartments, function(dept) {

        var numWorkPeriodsInDepartment = 0;
        dept.positions = _.map(_.where(dept.positions, {active: true}), function (pos) {
          pos._workPeriods = _.where($scope.workPeriods, function(wp) {
            return wp.active && wp.position_id === pos.id &&
              ($scope.state.anyAssignment || (wp.$isAssigned() && $scope.state.assignedOnly) || (!wp.$isAssigned() && $scope.state.unassignedOnly)) &&
              ($scope.state.anyPublish || (wp.$isPublished() && $scope.state.publishedOnly) || (!wp.$isPublished() && $scope.state.unpublishedOnly));
          });

          // if a position was selected and the most recent state change caused that pos to have 0 workperiods, clear it's selected state
          if (pos._workPeriods.length === 0 && pos._numWorkPeriods > 0) {
            pos._selected = false;
          }

          pos._numWorkPeriods = pos._workPeriods.length;

          numWorkPeriodsInDepartment += pos._numWorkPeriods;
          return pos;
        });
        dept._numWorkPeriods = numWorkPeriodsInDepartment;
        updateDepartmentAnyAll(dept);
      });

      updateTotalNumWorkPeriodsSelected();
    };

    _.each(['state.assignmentSelection', 'state.publishSelection'], function(prop) {
      $scope.$watch(prop, function() {
        setAssignmentPublishState();
        calcNumWorkPeriods();
      });
    });

    setAssignmentPublishState();
    calcNumWorkPeriods();


  });
